//---- Angular -----
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';

import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
//---- 3rdparty ----
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';

import { filter, Subscription } from 'rxjs';
//---- Hostware ----

import { Platform } from '@angular/cdk/platform';
import { SwUpdate } from '@angular/service-worker';
import { TranslateService } from '@ngx-translate/core';
import { BrandingDto } from '../../../froexishared/src/dto/BrandingDto';
import { SubscriberParameter } from '../../../froexishared/src/dto/SubscriberParameter';
import { BrandingService } from '../../../froexishared/src/services/branding.service';
import { SubscriberParameterService } from '../../../froexishared/src/services/SubscriberParameter.service';
import { GenericMessageDialogComponent } from './dialogs/generic-message-dialog/generic-message-dialog.component';
import { GuestLogin } from './dto/GuestLogin';
import { GuestLoginResponse } from './dto/GuestLoginResponse';
import { ReservationInfo } from './dto/ReservationInfo';
import HwUtils from './helpers/HwUtils';
import SessionStorage from './helpers/SessionStorage';
import { PaymentConfiguration } from './interfaces/PaymentSettings';
import { UrlData } from './interfaces/UrlData';
import { AuthService } from './services/auth.service';
import { BottomBarService } from './services/bottom-bar.service';
import { IpAddressService } from './services/ip-address-service';
import { LocalStorageService } from './services/localstorage.service';
import { LogService } from './services/log.service';
import { ReservationService } from './services/reservation.service';
import { RouterOutletService } from './services/router-outlet.service';
import { SpinnerService } from './services/spinner.service';
import { UrlDataService } from './services/urlData.service';
import { GuestStayStatus } from './types/Types';

@AutoUnsubscribe()
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'froexi_cutomerfacing';
  spinnerVisible: boolean;
  bottomBarVisible: boolean = true;
  loadBrandings$: Subscription;
  loadSubscriberParameters$: Subscription;

  invited: string | undefined = undefined;
  urlData: UrlData;

  modalPwaEvent: any;
  modalPwaPlatform: string | undefined;

  constructor(
    private router: Router,
    private reservationService: ReservationService,
    private authService: AuthService,
    private spinnerService: SpinnerService,
    private bottomBarService: BottomBarService,
    private errorDialog: MatDialog,
    private translate: TranslateService,
    private brandingService: BrandingService,
    private urlDataService: UrlDataService,
    private routerOutletService: RouterOutletService,
    private subscriberParamaterService: SubscriberParameterService,
    private localStorageService: LocalStorageService,
    private ipService: IpAddressService,
    private dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private platform: Platform,
    private swUpdate: SwUpdate,
    private logservice: LogService
  ) {
    SessionStorage.MrzData = undefined;
    SessionStorage.FaceImageFromCard = '';
    SessionStorage.Selfie = '';

  }

  ngOnInit() {




    this.spinnerService.spinnerVisibilityChanged.subscribe(event => {
      this.spinnerVisible = event;
    })
    this.loadModalPwa();
    this.activatedRoute.queryParams.pipe(filter((p: any) => p.guestStayUuid)).subscribe(urlData => {
      SessionStorage.GuestStayUuid = urlData.guestStayUuid
      this.urlData = urlData
      this.navigateForward()
    })

    this.activatedRoute.queryParams.pipe(filter((p: any) => p.tablet)).subscribe(urlData => {
      this.router.navigateByUrl("/startcheckin")
    })

    // TODO: Szebb megoldás, de le kellene tesztelni
    // this.activatedRoute.queryParams
    // .pipe(filter(params => Object.keys(params).length > 0))
    // .subscribe((params: any) => {
    //   console.log(params)
    //   if (!params.tablet) {
    //     SessionStorage.GuestStayUuid = params.guestStayUuid;
    //     this.urlData = params;
    //     this.navigateForward();
    //   } else {
    //     this.router.navigateByUrl("/startcheckin");
    //   }
    // })

    this.bottomBarService.bottomBarVisibilyChanged.subscribe(params => {
      this.bottomBarVisible = params
    })
  }


  navigateForward() {
    // if (!LocalStorage.IsTabletMode) {
    this.spinnerService.setSpinnerVisibility(true);
    if (this.urlData.invite === "true") {
      this.invited = 'Y'
      SessionStorage.Invited = 'Y'
    } else {
      this.invited = 'N'
      SessionStorage.Invited = 'N'
    }
    const guestLogin: GuestLogin =
    {
      GuestStayId: this.urlData.guestStayUuid,
      Hotel3pId: this.urlData.hotel3pId
    };



    this.authService.CreateGuestToken(guestLogin).subscribe({
      next: (loginRes) => {
        this.reservationService.getResNum(guestLogin.Hotel3pId, guestLogin.GuestStayId).subscribe((data: any) => {
          SessionStorage.ReservationNumber = data.ReservationNum.Resnum
        })

        const guestLoginRestponse = loginRes as GuestLoginResponse;
        SessionStorage.GuestData = guestLoginRestponse;
        SessionStorage.RetryCountImage = 0;
        SessionStorage.RetryCountMrz = 0;
        SessionStorage.RetryCountSelfie = 0;

        /**
         * Lekérjük a foglalás adatait.
         */
        this.reservationService.GetReservationInfo(this.urlData.guestStayUuid, this.invited, 'hu').subscribe({
          next: (result) => {
            this.spinnerService.setSpinnerVisibility(false);
            let res = result as ReservationInfo;
            const guestStatus = this.guestStatus(res, this.urlData.guestStayUuid)
            if (guestStatus == GuestStayStatus.CHECKED_OUT || this.guestStatus(res, this.urlData.guestStayUuid) == GuestStayStatus.CANCELED) {
              if (guestStatus == GuestStayStatus.CHECKED_OUT) {
                this.router.navigateByUrl('checkedoutguest')
              }
              if (guestStatus == GuestStayStatus.CANCELED) {
                this.router.navigateByUrl('canceledguest')
              }
            } else {
              res.Rooms.forEach(reservation => {
                reservation.Guests = reservation.Guests.filter(guest => guest.Status !== GuestStayStatus.CANCELED)
              })
              res.Rooms = res.Rooms.filter(item => item.Guests.length > 0)
              res.Invited = this.invited;
              SessionStorage.ReservationInfo = res;
              SessionStorage.MrzData = undefined;
              SessionStorage.FaceImageFromCard = '';
              SessionStorage.Selfie = '';
              this.loadBrandings$ = this.brandingService.LoadOnebySubscriber(HwUtils.getSubscriber(), HwUtils.getHotelId()).subscribe(result => {
                const br = result as BrandingDto;
                if (br) {
                  SessionStorage.BrandingData = br;
                }
                if (this.hasRegisteredGuest(res)) {
                  this.router.navigateByUrl('/languageselection')
                } else {
                  this.errorModalWithMessage('app.no_registered_guest')
                }
              })
              this.loadSubscriberParameters$ = this.subscriberParamaterService.loadAll(HwUtils.getSubscriber(), HwUtils.getHotelId()).subscribe(result => {
                const parameters = result as SubscriberParameter[];
                SessionStorage.ChatVisibility = parameters.find(item => item.Param_Typecode == "CHAT_VISIBILITY").Param_String_Value;
                SessionStorage.ChatActiveHours = parameters.find(item => item.Param_Typecode == "CHAT_ACTIVE_HOURS").Param_String_Value;
                SessionStorage.PhotoInTabletMode = parameters.find(item => item.Param_Typecode == "PHOTO_IN_EXI_TABLET").Param_Int_Value;
                SessionStorage.PhotoInExi = parameters.find(item => item.Param_Typecode == "PHOTO_IN_EXI").Param_Int_Value;
                SessionStorage.PhotoInTabletApp = parameters.find(item => item.Param_Typecode == "PHOTO_IN_TABLET_APP").Param_Int_Value;
                SessionStorage.EnablePayment = parameters.find(item => item.Param_Typecode == "ENABLE_PAYMENT").Param_Int_Value == 1 ? true : false;
                const paymentParams = parameters.find(item => item.Param_Typecode == "PAYMENT_PARAMETERS").Param_Json_Value;
                const paymentSettings = JSON.parse(paymentParams) as PaymentConfiguration;
                // Bármelyik fizetési mód EUR-t is támogat (pl. "HUF,EUR", "EUR,HUF", "EUR") -> valutaváltó switch
                SessionStorage.HasEurPayment = paymentSettings.BIGFISH.Paymodes.some(paymode =>
                  (paymode.PaymentCurrency ?? '').split(',').some(currency => currency.trim() == "EUR"))
              })
              this.ipService.getIpFromIpify().subscribe(result => {
                SessionStorage.IpAddress = result as string;
              })
            }

          },
          error: (err: HttpErrorResponse) => {
            console.log(err)
            this.errorModalWithMessage('app.invalid_reservation_data');
          }
        })
      },
      error: (err: HttpErrorResponse) => {
        console.log(err)
        this.errorModalWithMessage('app.out_of_service');
      }
    }
    )
    // }  else {
    //     this.router.navigateByUrl('/startchekin')
    // }

  }
  ngOnDestroy(): void {
    this.loadBrandings$?.unsubscribe();
    this.loadSubscriberParameters$?.unsubscribe();
  }

  errorModalWithMessage(errorMessage: string) {
    this.spinnerService.setSpinnerVisibility(false);
    this.errorDialog.open(GenericMessageDialogComponent, {
      disableClose: true,
      hasBackdrop: true,
      width: "auto",
      data: { messageText: this.translate.instant(errorMessage), messageType: 'ERROR' }
    })
  }

  hasRegisteredGuest(resInfo: ReservationInfo): boolean {
    let hasReg: boolean = false;
    resInfo.Rooms.forEach(room => {
      room.Guests.forEach(guest => {
        if (guest.Status == GuestStayStatus.REGISTERED || GuestStayStatus.ROOM_AVAILABLE) {
          hasReg = true;
        }
      })
    })
    return hasReg;
  }

  guestStatus(resInfo: ReservationInfo, guestStayUuid: string): GuestStayStatus {
    let guestStatus: GuestStayStatus
    resInfo.Rooms.forEach(room => {
      room.Guests.forEach(guest => {
        if (guest.GuestStayUuId == guestStayUuid) {
          guestStatus = guest.Status;
        }
      })
    })
    return guestStatus
  }

  guestExists(resInfo: ReservationInfo, guestStayUuid: string): boolean {
    let guestExists: boolean = false;
    resInfo.Rooms.forEach(room => {
      room.Guests.forEach(guest => {
        if (guest.GuestStayUuId == guestStayUuid) {
          guestExists = true;
        }
      })
    })
    return guestExists;
  }
  bottomBarStyle(visible: boolean) {
    let styles = {};
    styles["visibility"] = this.bottomBarVisible ? 'visible' : 'hidden'
    styles["background-color"] = SessionStorage.BrandingData.PrimaryColor;
    return styles;
  }

  backStyle() {
    let styles = {};
    styles["background-color"] = SessionStorage.BrandingData.PrimaryColor;
    return styles
  }

  hasBrandingData(): boolean {
    return SessionStorage.BrandingData ? true : false
  }

  outletActivated(event: RouterOutlet) {
    this.routerOutletService.setRouterContentChanged(event)
  }


  private loadModalPwa(): void {
    if (this.platform.ANDROID) {
      window.addEventListener('beforeinstallprompt', (event: any) => {
        event.preventDefault();
        this.modalPwaEvent = event;
        this.modalPwaPlatform = 'ANDROID';
        this.modalPwaEvent.prompt();
        this.modalPwaPlatform = undefined;
      });
    }
    if (this.platform.isBrowser) {
      window.addEventListener('beforeinstallprompt', (event: any) => {
        event.preventDefault();
        this.modalPwaEvent = event;
        this.modalPwaPlatform = 'BROWSER';
        this.modalPwaEvent.prompt();
        this.modalPwaPlatform = undefined;
      });
    }
  }

  public addToHomeScreen(): void {
    this.modalPwaEvent.prompt();
    this.modalPwaPlatform = undefined;
  }
}
